import React from "react";
import Navbar from "../Component/Navbar/Navbar";
import Changepassword from "../Component/Auth/Changepassword";
// import Changepassword from "../Component/Auth/Changepassword";

const ChangePassword = () => {
  return (
    <>
      <Navbar />
      <Changepassword />
    </>
  );
};

export default ChangePassword;
